import { LegendWeek } from "../../components/legend/legendWeek";
import DayAgenda from "../../components/planning/dayAgenda";

export function PlanninDays() {

    return (
        <div>
            <DayAgenda />
            <LegendWeek />
        </div>
    );
}